__turbopack_context__.v({
  "wrapper": "_8s1jwq_wrapper",
  "wrapper__label": "_8s1jwq_wrapper__label",
});
